import * as model from "@/model/prd/qualityMgt/pelletizing/QualitySamplePlan";
import router from "@/router/index";
import {
  newEntityStoreHelper
} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
  var filter = Object.assign({}, paginationFilter, model.filter)
  return filter;
}

export default newEntityStoreHelper(() => new model.QualitySamplePlan(), newFilter)
  .withStates({
    idReport: 2,
    baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd",
    qualityPlanStatus: '',
  }) //TODO load at the application start
  .withActions({
    qualityPlanStatus(context, entity) {

      context.state.qualityPlanStatus = entity;

    },
    Save(context, entity) {
      context.state.entity.planId = context.state.qualityPlanStatus.id;

      return context.dispatch("api/put", {
          url: context.state.baseModuleUrl + "/" + entity,
          entity: context.state.entity,
          moudle: entity
        }, {
          root: true
        })
        .then(function () {
          context.dispatch("base/showSuccess", {
            userAlertSuccessStr: "Success!",
            dismissCountDown: 3,
            userAlertSuccessVisible: false,
          }, {
            root: true
          }).then(function () {
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/qualityPlan" + "/findById/" + context.state.entity.planId
              }, {
                root: true
              })
              .then(response => {

                {
                 
                
                  context.commit('qualitySamplePlan' + "/setRows", response.qualitySamplePlans, {
                    root: true
                  });
                  router.push({
                    path: '/prd/qualitySamplePlan',
                    query: {
                        id: context.state.entity.planId
                    }
                });
                }
              });
          })
        })



    },
    Sent(context, entity) {
      context.state.entity.planId = context.state.qualityPlanStatus.id;
      var checkedItems = context.rootState[entity]["checkedItems"];
      if (checkedItems) {
          var params =  checkedItems.join(',');

      }
      context.dispatch("api/get", {
          url: context.state.baseModuleUrl + "/" + entity + "/sent/"+params
        }, {
          root: true
        })
        .then(function () {
          context.dispatch("base/showSuccess", {
            userAlertSuccessStr: "Sucess!",
            dismissCountDown: 5,
            userAlertSuccessVisible: false,
          }, {
            root: true
          }).then(function () {
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/qualityPlan" + "/findById/" + context.state.entity.planId,
              }, {
                root: true
              })
              .then(response => {

                {

                  context.commit('qualitySamplePlan' + "/setRows", response.qualitySamplePlans, {
                    root: true
                  });
                }
              });
          })
        })



    },
    Delete(context) {
      context.state.entity.planId = context.state.qualityPlanStatus.id;
      var checkedItems = context.state["checkedItems"];
      if (checkedItems) {
          var params = 'id=' + checkedItems.join(',');    
                  
      }
      context.dispatch("api/delete", { //发送请求
          url: context.state.baseModuleUrl + ("/qualitySamplePlan"+ "?" + params)
      }, { root: true })
          .then(function () { // doing search again
              context.dispatch("base/showSuccess", {
                  userAlertSuccessStr: "Deleted!",
                  dismissCountDown: 5,
                  userAlertSuccessVisible: false,
              }, { root: true }).then(function () {
                  context.dispatch("api/get", {
                      url: context.state.baseModuleUrl + "/qualityPlan" + "/findById/" + context.state.entity.planId
                  }, { root: true })
                      .then(response => {

                          {

                              context.commit('qualitySamplePlan' + "/setRows", response.qualitySamplePlans, { root: true });
                          }
                      });
              })
          });



  },
  BackToList(context){
    router.push({
      path: '/prd/qualitySamplePlan',
      query: {
          id: context.state.qualityPlanStatus.id
      }
  });
  },
  })
  .buildStore()